<script>
/**
 * Footer component
 */
export default {
  name: 'Footer'
}
</script>

<template>
  <div>
    <!--START FOOTER-->
    <footer class="footer">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 margin-t-20">
            <h4>Aztlan Labs</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <li>
                  <a href="#">Inicio</a>
                </li>
                <li>
                  <a href="#">¿Como lo hacemos?</a>
                </li>
                <li>
                  <a href="#">Servicios</a>
                </li>
                
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Información</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                <!--li>
                  <a href="#">Terminos y Condiciones</a>
                </li-->
                <li>
                  Telefonos
                </li>
                <li>
                  777-231-3119
                </li>
                <li>
                  554-002-4045
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>Contactanos</h4>
            <div class="text-muted margin-t-20">
              <ul class="list-unstyled footer-list">
                
                <li>
                  hola@aztlanlabs.com
                </li>
                <li>
                  San Jerónimo #207
                  Colonia Tlaltenango
                  
                </li>
                <li>
                  Cuernavaca, Morelos
                  62170 México
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-3 margin-t-20">
            <h4>SOMOS #AztlanLabs</h4>
            <div class="text-muted margin-t-20">
              <p>Creamos experiencias que transforman procesos o actividades y que presentan valor agregado para nuestros colaboradores, clientes y proveedores.</p>
            </div>
          </div>
        </div>
      </div>
    </footer>
    <!--END FOOTER-->

    <!--START FOOTER ALTER-->
    <div class="footer-alt">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="float-left pull-none">
              <p
                class="copy-rights text-muted mb-3 mb-sm-0"
              >2017 - {{ new Date().getFullYear()}} © Aztlan Labs S.A. de C.V. - Imaginación Tangible</p>
            </div>
            <div class="float-right pull-none">
              <ul class="list-inline social m-0">
                <li class="list-inline-item">
                  <a href="https://www.facebook.com/AztlanLabsOficial" target="_blank" class="social-icon">
                    <i class="mdi mdi-facebook"></i>
                  </a>
                </li>
                <!--li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-twitter"></i>
                  </a>
                </li-->
                <li class="list-inline-item">
                  <a href="https://www.linkedin.com/company/aztlan-labs/" target="_blank" class="social-icon">
                    <i class="mdi mdi-linkedin"></i>
                  </a>
                </li>
                <!--li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-google-plus"></i>
                  </a>
                </li>
                <li class="list-inline-item">
                  <a href class="social-icon">
                    <i class="mdi mdi-dribbble"></i>
                  </a>
                </li-->
              </ul>
            </div>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
    <!--START FOOTER ALTER-->
  </div>
</template>